const ProjectRoutes = {
  getProjectName: 'admin/gpt/project/getName',
  updateProjectName: 'admin/gpt/project/updateName',
  getProjectDetail: 'admin/gpt/project/getdetail',
  updateProject: 'admin/gpt/project/update',
};

export default ProjectRoutes